"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVersion = void 0;
var IVersion;
(function (IVersion) {
    IVersion["V0"] = "v0";
    IVersion["V2"] = "v2";
})(IVersion || (exports.IVersion = IVersion = {}));
//# sourceMappingURL=version.js.map